import React from 'react'
import { CopyIcon } from '../icons'
import copy from 'copy-to-clipboard'

import S from './styled'

const CopyText = ({ message }) => (
  <S.CopyText>
    <div style={{ flex: '1 1' }}>{message}</div>
    <S.CopyButton onClick={() => copy(message)}><CopyIcon/></S.CopyButton>
  </S.CopyText>
)
export default CopyText
